export const projectCardButton = () => ({
  cursor: 'pointer',
  fontSize: 8,
  fontWeight: 900,
  width: 'fitContent',
  '&hover': { color: '#f557ef' },
  mr: { sm: 3 },
});
